/* ============================================================
   LIVE BEARDED — Beard Boost Advertorial v4
   ============================================================ */

(function () {
  'use strict';

  // ============ DYNAMIC DATE ============
  const dateEl = document.getElementById('heroDate');
  if (dateEl) {
    dateEl.textContent = new Date().toLocaleString('en-US', { month: 'long', year: 'numeric' });
  }

  // ============ READING PROGRESS BAR ============
  const bar = document.getElementById('progressBar');
  if (bar) {
    let ticking = false;
    const update = () => {
      const h = document.documentElement;
      const max = h.scrollHeight - h.clientHeight;
      const pct = max > 0 ? (h.scrollTop / max) * 100 : 0;
      bar.style.width = pct + '%';
      ticking = false;
    };
    document.addEventListener('scroll', () => {
      if (!ticking) {
        requestAnimationFrame(update);
        ticking = true;
      }
    }, { passive: true });
    update();
  }

  // ============ INTERSECTION REVEAL ============
  if ('IntersectionObserver' in window) {
    const io = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-in');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });

    document.querySelectorAll('.pathway, .timeline__node, .comment, .sliderbox').forEach((el) => {
      el.classList.add('reveal');
      io.observe(el);
    });
  }

  // ============ TRIAL BAR ANIMATION (replay on scroll-in) ============
  if ('IntersectionObserver' in window) {
    const trial = document.querySelector('.trial');
    if (trial) {
      const io2 = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            trial.querySelectorAll('.trial__bar-fill').forEach((el) => {
              el.style.animation = 'none';
              // Force reflow
              void el.offsetWidth;
              el.style.animation = '';
            });
            io2.unobserve(trial);
          }
        });
      }, { threshold: 0.3 });
      io2.observe(trial);
    }
  }

  // ============ SEE MORE REVIEWS ============
  const moreBtn = document.getElementById('loadMoreBtn');
  if (moreBtn) {
    let nextBatch = 1;
    moreBtn.addEventListener('click', () => {
      const cards = document.querySelectorAll(`.comment[data-batch="${nextBatch}"]`);
      cards.forEach(el => el.classList.remove('comment--locked'));
      nextBatch++;
      if (nextBatch > 3) {
        const wrap = document.getElementById('commentsMoreWrap');
        if (wrap) wrap.style.display = 'none';
      }
    });
  }

  // ============ ACCORDION: only one FAQ open at a time ============
  const faqs = document.querySelectorAll('.faq__item');
  faqs.forEach((item) => {
    item.addEventListener('toggle', () => {
      if (item.open) {
        faqs.forEach((other) => {
          if (other !== item && other.open) other.open = false;
        });
      }
    });
  });

})();
